import { NUMBER_SIZE } from '../../../constants/size'

export const SIZES = [
  NUMBER_SIZE.size48,
  NUMBER_SIZE.size40,
  NUMBER_SIZE.size32,
  NUMBER_SIZE.size24,
]
